export const EUROASIANN_BANK_DETAILS = {
  accountName: 'Euroasiann Marine Spares Pvt Ltd',
  accountNumber: '925020003567719',
  ifscCode: 'UTIB0001634',
  bankName: 'Axis Bank',
} as const;

export function formatEuroasiannBankDetailsBlock(): string[] {
  return [
    `Account Name: ${EUROASIANN_BANK_DETAILS.accountName}`,
    `Account Number: ${EUROASIANN_BANK_DETAILS.accountNumber}`,
    `IFSC Code: ${EUROASIANN_BANK_DETAILS.ifscCode}`,
    `Bank: ${EUROASIANN_BANK_DETAILS.bankName}`,
  ];
}
